import * as io from "io-ts";

export const SymptomChartType = io.keyof({
  amplitude: null,
  gap: null,
  normalizedGap: null,
});
export type SymptomChartType = io.TypeOf<typeof SymptomChartType>;
